import { NeedCookies } from "@/features/portal/components/auth/need-cookies";

/** `/portal/cookies` — shown when the session cookie can't be set. */
export default function NeedCookiesPage() {
  return <NeedCookies />;
}
